<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div class="card-body" v-if="pacientes.length > 0">
        <div class="card" style="border-radius: 10px; align-items: center">
          <h1>FAVORITOS</h1>
        </div>
      </div>
      <div
        @click="editarPaciente(pacientes.id)"
        class="card card-style mt-3"
        v-for="pacientes in pacientes"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body">
          <h3 class="card-title">{{ pacientes.nome_paciente }}</h3>
          <h5>Idade: {{ pacientes.idade }}</h5>
          <h5>
            Sexo:
            {{
              pacientes.sexo === "F"
                ? "Feminino"
                : pacientes.sexo === "M"
                ? "Masculino"
                : ""
            }}
          </h5>
        </div>
      </div>

      <p
        class="sem-registros"
        v-if="pacientes.length == 0"
        style="text-align: center; margin-top: 78%; font-size: 16px"
      >
        Nenhum paciente cadastrado. <br />
        Clique no botão abaixo para cadastrar.
      </p>

      <router-link
        style="margin-left: 15px; margin-right: 0px"
        to="/adicionar-paciente"
        class="form-group botao-cadastrar"
      >
        <div class="col-md-12">
          <button type="button" class="btn">CADASTRAR</button>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import HeaderNavbar from "../layout/HeaderNavbar.vue";
import LeftNavbar from "../layout/LeftNavbar.vue";
export default {
  data() {
    return {
      perfil: {
        nome: "",
        login: "",
        senha: "",
        confirmar_senha: "",
      },
      usuario_id: {
        usuario_id: "",
      },
      pacientes: "",
      isLoading: false,
      loadingColor: "#5D9CEC",
      isDisabled: true,
    };
  },
  computed: {
    usuarioId() {
      const self = this;
      self.perfil.usuario_id = this.$store.state.usuario_id;
    },
  },
  methods: {
    getPacientes(id) {
      const self = this;
      self.isLoading = true;

      this.usuario_id.usuarioid = id;

      const api = self.$store.state.api + "pacientes/usuario_id/" + id;
      axios
        .get(api, this.usuario_id)
        .then((response) => {
          self.pacientes = response.data;
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.isLoading = false;
        });
    },
    editarPaciente(id) {
      const self = this;
      self.isLoading = true;
      this.$router.push("/editar-paciente/" + id);
      /* this.$router.push({
        path: this.$router + "/editar-paciente/" + id,
      }); */
    },
  },
  components: {
    HeaderNavbar,
    LeftNavbar,
    Loading,
  },
  props: {
    source: String,
  },
  mounted: function () {
    const self = this;

    self.isLoading = true;

    var id = localStorage.getItem("usuario_id");

    self.getPacientes(id);

    this.authenticated = this.$store.getters.authenticated;

    $("body").removeClass("top-navigation");
    $("body").removeClass("custom-login");

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    document.body.setAttribute("style", null);

    /* let id = this.usuarioId;
    if (id) {
      self.getUsers(id);
    } */
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* CUSTOMIZACOES INPUTS */
.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15);
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.botao-cadastrar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.sem-registros {
  position: fixed;
  bottom: 50%;
  width: 100%;
  /* padding-left: 10px;
  padding-right: 10px; */
}

.btn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

h5 {
  font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Pacientes/Pacientes.vue